module.exports = "<input type=\"hidden\"\n  [id]=\"idInput\"\n  [name]=\"name\"\n  [value]=\"value\"\n  [disabled]=\"disable\"\n  [(ngModel)]=\"switchValue\" />\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/atoms/alg-switch/alg-switch.component.html
// module id = ./src/app/components/atoms/alg-switch/alg-switch.component.html
// module chunks = main